import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { registerInfluenceur } from "../services/InfluenceurService"; // service pour influenceur
import { setAuthInfluenceur, selectAuthInfluenceur } from "../Redux/authInfluenceurSlice";

const RegisterPageInfluenceur = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const auth = useSelector(selectAuthInfluenceur);

    const [nomComplet, setNomComplet] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (auth?.isAuthenticated && auth?.token) {
            navigate("/influenceur"); // page dashboard influenceur
        }
    }, [auth, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");

        if (!nomComplet || !email || !password) {
            setLoading(false);
            setErrorMessage("Veuillez remplir tous les champs.");
            return;
        }

        try {
            const response = await registerInfluenceur(nomComplet, email, password);

            if (response.success) {
                dispatch(setAuthInfluenceur({ token: response.token, email, nomComplet }));
                setLoading(false);
                navigate("/influenceur"); // redirection vers le dashboard après inscription
            } else {
                setLoading(false);
                setErrorMessage(response.message || "Échec de l'inscription.");
            }
        } catch (error) {
            setLoading(false);
            setErrorMessage("Erreur inattendue.");
        }
    };

    return (
        <div className="flex justify-center items-center w-screen h-screen bg-color1 px-4">
            <div className="w-full lg:w-1/2 max-w-md bg-white p-8 rounded-2xl shadow-lg">
                <h1 className="text-3xl lg:text-4xl font-bold text-blue-800">Créer un compte Influenceur</h1>
                <p className="mt-2 text-sm lg:text-base text-blue-700">
                    Inscrivez-vous pour gérer vos clients, suivre vos commissions et accéder à vos statistiques.
                </p>

                {errorMessage && (
                    <div className="mt-4 bg-red-100 text-red-600 text-sm p-2 rounded">
                        {errorMessage}
                    </div>
                )}

                <div className="mt-5 flex flex-col gap-2">
                    <label className="text-sm lg:text-base text-blue-700">Nom complet</label>
                    <input
                        type="text"
                        value={nomComplet}
                        onChange={(e) => setNomComplet(e.target.value)}
                        placeholder="Votre nom complet"
                        className="w-full px-3 py-2 border rounded-lg text-black focus:outline-none focus:ring-2 focus:ring-blue-400 placeholder:text-blue-600"
                    />
                </div>

                <div className="mt-4 flex flex-col gap-2">
                    <label className="text-sm lg:text-base text-blue-700">Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="votre@email.com"
                        className="w-full px-3 py-2 border rounded-lg text-black focus:outline-none focus:ring-2 focus:ring-blue-400 placeholder:text-blue-600"
                    />
                </div>

                <div className="mt-4 flex flex-col gap-2">
                    <label className="text-sm lg:text-base text-blue-700">Mot de passe</label>
                    <input
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="********"
                        className="w-full px-3 py-2 border rounded-lg text-black focus:outline-none focus:ring-2 focus:ring-blue-400 placeholder:text-blue-600"
                    />
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="text-xs text-blue-600 self-end mt-1"
                    >
                        {showPassword ? "Masquer" : "Afficher"} le mot de passe
                    </button>
                </div>

                <button
                    onClick={handleSubmit}
                    disabled={loading}
                    className="mt-6 w-full bg-blue-800 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition disabled:opacity-50"
                >
                    {loading ? "Inscription..." : "S'inscrire"}
                </button>
            </div>
        </div>
    );
};

export default RegisterPageInfluenceur;
